import script from "./PagasPorPagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./PagasPorPagamento.vue?vue&type=script&setup=true&lang=js"

import "./PagasPorPagamento.vue?vue&type=style&index=0&id=2e6340b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e6340b2"]])

export default __exports__